export default function () {
  if (typeof window === "undefined") return false
  if (!document.body) return false

  const bait = document.createElement("div")
  bait.className =
    "ad-banner ads ad-placement ad-placeholder textads banner-ads"
  bait.setAttribute("id", "ad-banner")
  Object.assign(bait.style, {
    height: "1px",
    width: "1px",
    position: "absolute",
    left: "-9999px",
    top: "-9999px",
  })

  document.body.appendChild(bait)

  const styles = getComputedStyle(bait)
  // Only return true when ad blocker explicitly overrode our styles
  const isBlocked =
    styles.display === "none" ||
    styles.visibility === "hidden" ||
    styles.opacity === "0" ||
    bait.offsetHeight === 0

  document.body.removeChild(bait)

  return isBlocked
}
